import { TRoutes } from "../routes.types";

export const funnel = {
} satisfies TRoutes;
